<template>
  <div>
    <div class="air__utils__heading">
      <div class="row">
        <div class="col-6 col-sm-8">
          <h5>Requests</h5>
        </div>
<!--        <div class="col-6 col-sm-4 text-right">
          <new-product v-if="pagepermission.insertable" @created="handleCreated"/>
        </div>-->
      </div>
    </div>
    <div class="row justify-content-center" v-if="pagepermission.viewable">
      <!-- Student Search -->
      <div class="col-md-6 col-12 mb-2" v-if="true">
        <div class="text-right">
          <a-input-search
            placeholder="Search Request ID and Subject"
            size="large"
            v-model="search"
            @search="searchRequests"
          />
        </div>
      </div>
      <div class="col-md-3 col-12 mb-2" v-if="true">
          <a-date-picker
            placeholder="Created on"
            size="large"
            v-decorator="['start_date', {rules: [{ required: true, message: 'Please input a start date' }], initialValue: moment()},]"
            :format=dateFormat
            @change="handleCreatedOnDatePickerChange"
          />
      </div>
      <div class="col-md-3 col-12 mb-2" v-if="true">
        <a-date-picker
          placeholder="Updated on"
          size="large"
          v-decorator="['start_date', {rules: [{ required: true, message: 'Please input a start date' }], initialValue: moment()},]"
          @change="handleUpdatedOnDatePickerChange"
        />
      </div>
      <div class="col-xl-12">
        <div class="card">
          <div class="card-body">
            <requests-table :data="data" :rolesetting="pagepermission" :loading="loading" @updateTable="handleUpdateTable" />
          </div>
        </div>
        <div class="text-right">
          <a-pagination
              showSizeChanger
              @showSizeChange="onShowSizeChange"
              :total="meta.total"
              :pageSize.sync="pageSize"
              v-model="current"
              @change="onChange"
            >
          </a-pagination>
        </div>
      </div>
    </div>
    <div class="row justify-content-center" v-else>
      <p class="error">
        You don't have permission to use this feature.
      </p>
    </div>
  </div>
</template>

<script>
import RequestsTable from '@/components/support/requests/index'
// import NewProduct from '@/components/inventory/master/product/new'
import moment from 'moment'

export default {
  components: {
    RequestsTable,
    // NewProduct,
  },
  beforeMount: function() {
    let rc = this.$roleutility.checkpermission('support', 22)
    rc.then(data => {
      console.log('RoleCheck!Data processed. ', data)
      this.pagepermission = data.pagePermission
    })
  },
  mounted: function() {
    this.getRequests()
  },
  data: function() {
    return {
      loading: false,
      visible: false,
      data: [],
      meta: {},
      current: 1,
      pageSize: 30,
      pagepermission: {
        insertable: false,
        editable: false,
        viewable: false,
        deletable: false,
      },
      filters: null,
      sorter: null,
      search: null,
      createdOn: null,
      updatedOn: null,
      dateFormat: 'DD-MMM-YYYY',
      // searchRaisedBy: null,
    }
  },
  methods: {
    moment,
    getRequests: function(isSearch) {
      console.log('here')
      this.loading = true
      let page = this.current
      if (isSearch) {
        page = 1
        this.current = 1
      }
      this.$http.get('/api/support_request', {
        params: {
          limit: this.pageSize,
          page: page,
          filters: this.filters,
          search: this.search,
          sorter: this.sorter,
          created_on: this.createdOn == null ? null : moment(this.createdOn).format('YYYY-MM-DD'),
          updated_on: this.updatedOn == null ? null : moment(this.updatedOn).format('YYYY-MM-DD'),
        },
      }).then(({ data }) => {
        this.loading = false
        this.data = data.data
        this.meta = data.meta
      })
    },
    searchRequests: function(value) {
      console.log(value)
      this.search = value
      this.getRequests(true)
    },
    handleCreatedOnDatePickerChange: function (value) {
      console.log('datePicker', value)
      this.createdOn = value
      this.getRequests()
    },
    handleUpdatedOnDatePickerChange: function (value) {
      console.log('datePicker', value)
      this.updatedOn = value
      this.getRequests()
    },
    handleCreated: function() {
      this.getRequests()
    },
    handleUpdateTable: function(args) {
      if (args !== null && args !== undefined) {
        this.filters = args.filters
        // this.searchRaisedBy = args.searchRaisedBy
        console.log(args.sorter)
        this.sorter = { 'field': args.sorter.field, 'order': args.sorter.order }
        /* this.sorterField = args[0]
        this.sorterOrder = args[1] */
      }

      console.log('Hererer', this.filters)
      this.getRequests()
    },
    onShowSizeChange(current, pageSize) {
      this.pageSize = pageSize
      this.current = current
      this.getRequests()
    },
    onChange(current) {
      this.current = current
      this.getRequests()
    },
  },
}
</script>
<style>
.error { padding: 25px 5px; }
</style>
